<template>
  <div class="container-fluid py-4">
    <div class="row">
      <div class="col-12">
        <div class="card">

          <!-- Table Header -->
          <div class="pb-0 card-header">
            <div class="d-lg-flex">
              <div class="p-0 text-start pt-2">
                <a class="p-0 back-button text-primary" style="cursor: pointer" :title="$t('key_purchaseDetailTableHeader_button_back')" @click="$router.go(-1)">
                  <i class="fa fa-arrow-circle-left" style="font-size: 35px;"></i>
                </a>
              </div>
              <div class="ms-3">
                  <h5 class="mb-0">{{ title }}</h5>
                  <p class="mb-0 text-sm">{{ description }}</p>
              </div>

              <div class="my-auto mt-4 ms-auto mt-lg-0">
                <div class="my-auto ms-auto mt-2">
                  <soft-button
                    v-if="canDownloadDeliveryNote"
                    class="btn-icon me-2"
                    color="primary"
                    variant="outline"
                    :disabled="isDownloadingDeliveryNote"
                    @click="onDownloadDeliveryNote">
                    <span class="btn-inner--icon">
                      <i class="fa-solid fa-file-pdf me-2"></i>
                    </span>
                    <span class="btn-inner--text">{{ $t('key_OrderDetail_button_delivery_note') }}</span>
                  </soft-button>
                  <!-- Interactions with database (filters and reload) -->
                  <ReloadButton :title="$t('key_orderListTableHeader_button_reload_order')" @change="getOrder"/>
                </div>
              </div>
            </div>
          </div>
          
          <!-- Only v2 has the progress endpoint. -->
          <div v-if="$PickoVersion.isV2()" class="px-3 pt-3">
            <order-progress />
          </div>

          <!-- Tabla con los Datos -->
          <div class="scrollable">
            <GenericTableScrollable
              v-if="!!pedidoData"
              ref="genericTable"
              :items="pedidoData.products"
              :headers="headers"
              :is-loading="isLoading"> <!-- @row-change="paginationRowChange" -->
              <template #row="pedido">
                <td style="width: 15rem" class="text-sm">
                  <div class="d-flex">
                    <div class="d-lg-flex">
                      <div>
                        <img class="d-inline" :class="!pedido.image? 'noimageColor': 'image'"  :src="!pedido.image? noimage: pedido.image" :alt="$t('key_products_image')" />
                      </div>
                      <div class="my-auto mt-4 ms-auto mt-lg-0">
                        <h6 class="my-auto text-sm ms-3">
                          <a href="#" class="text-xs text-primary" @click.prevent="goToDetalle(pedido.product_id)">
                            {{ pedido.name }}
                          </a>
                        </h6>
                        <span class="text-xs ms-3">
                          {{ pedido.property1 }} - {{ pedido.property2 }}
                        </span>
                      </div>
                    </div>
                  </div>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ pedido.ean }}</span>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ pedido.sku }}</span>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ pedido.batch }}</span>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ pedido.batch_date }}</span>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ pedido.warehouse }}</span>
                </td>
                <td style="width: 10%" class="units">
                  <ul class="text-xs">
                    <li><span class="my-2 text-xs text-info">{{ this.$t('key_orderList_requested') }}: {{ $numberFormat.toDecimalFormat(pedido.units.requested) }}</span></li>
                    <li><span class="my-2 text-xs text-danger">{{ this.$t('key_orderList_booked') }}: {{ $numberFormat.toDecimalFormat(pedido.units.booked) }}</span></li>
                    <li><span class="my-2 text-xs text-success">{{ this.$t('key_orderList_packaged') }}: {{ $numberFormat.toDecimalFormat(pedido.units.completed) }}</span></li>
                  </ul>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ $numberFormat.toCurrency(pedido.price, pedidoData.currency) }}</span>
                </td>
                <td style="width: 15%" class="font-weight-bold">
                  <span class="my-2 text-xs columns">{{ $numberFormat.toCurrency(pedido.amount, pedidoData.currency) }}</span>
                </td>
              </template>
            </GenericTableScrollable>
          </div>
          <div class="col-12 row">
            <order-footer :order="pedidoData" />
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

  import GenericTableScrollable from "../../../picko_components/generic_components/GenericTableScrollable.vue";
  import ReloadButton from "./../../../picko_components/generic_components/ReloadButton.vue";
  import SoftButton from "@/components/SoftButton.vue";
  import noimage from  "@/assets/img/sevica-images/noimage.png";
  // import OrderHeader from "./OrderHeader.vue";
  // import OrderProducts from "./OrderProducts.vue";
  import OrderFooter from "./OrderFooter.vue";
  import OrderProgress from "./OrderProgress.vue";

  export default {
    name: "OrderDetails",
    components: {
      // OrderHeader,
      // OrderProducts,
      GenericTableScrollable,
      OrderFooter,
      OrderProgress,
      ReloadButton,
      SoftButton
    },
    data() {
      return {
        noimage,
        isLoading: false,
        isDownloadingDeliveryNote: false
      };
    },
    computed: {
      pedidoData() {
        return this.$store.state.order.order.data;
      },
      headers() {
        return [
          //{ title: this.$t('key_theader_PurchaseDetail_id'), sort: { sorteable: true, order: '' }, column: 'id' },
          { title: this.$t('key_theader_OrderDetail_product'), sort: { sorteable: true, order: '' }, column: 'products.name' },
          { title: this.$t('key_theader_OrderDetail_ean'), sort: { sorteable: true, order: '' }, column: 'products.ean' },
          { title: this.$t('key_theader_OrderDetail_sku'), sort: { sorteable: true, order: '' }, column: 'products.sku' },
          { title: this.$t('key_theader_OrderDetail_batch'), sort: { sorteable: true, order: '' }, column: 'products.batch' },
          { title: this.$t('key_theader_OrderDetail_batch_date'), sort: { sorteable: true, order: '' }, column: 'products.batch_date' },
          { title: this.$t('key_theader_OrderDetail_warehouse'), sort: { sorteable: true, order: '' }, column: 'products.warehouse' },
          { title: this.$t('key_theader_OrderDetail_units'), sort: { sorteable: true, order: '' }, column: 'products.units' },
          { title: this.$t('key_theader_OrderDetail_price'), sort: { sorteable: true, order: '' }, column: 'products.price' },
          { title: this.$t('key_theader_OrderDetail_total'), sort: { sorteable: true, order: '' }, column: 'products.total' },
        ];
      },
      title() {
        return this.pedidoData ? this.pedidoData.number + ' - ' + this.$dateUtils.toNoHourLongDate(this.pedidoData.date) : '';
      },
      // The back only renders the delivery note of a finished order with a
      // shipment, and only v2 has the endpoint.
      canDownloadDeliveryNote() {
        return this.$PickoVersion.isV2()
          && !!this.pedidoData
          && this.pedidoData.status === 'FINALIZADO'
          && !!this.pedidoData.shipment;
      },
      description() {
        return this.pedidoData ? this.$t('key_OrderDetail_Reference') + ': ' + this.pedidoData.reference : '';
      }
    },
    watch: {
      pedidoData() {
        if(this.pedidoData){
          this.isLoading = false;
        }
      },
    },
    mounted() {
      this.getOrder();
    },
    methods: {
      goToDetalle(productId){
        this.$router.push({ path: "/MasterData/Products/EditProduct/" + productId});
      },
      getOrder() {
        if (this.isLoading) return;

        this.isLoading = true;
        this.$store.commit("order/getById", this.$route.params.id);
        this.$store.commit("order/getTracking", this.$route.params.id);
        if (this.$PickoVersion.isV2()) {
          this.$store.commit("order/getProgress", this.$route.params.id);
        }
      },
      async onDownloadDeliveryNote() {
        if (this.isDownloadingDeliveryNote) return;

        this.isDownloadingDeliveryNote = true;
        try {
          const blob = await this.$store.dispatch("order/downloadDeliveryNote", this.$route.params.id);
          const link = document.createElement("a");
          link.setAttribute("download", `delivery-note-${this.pedidoData.number}.pdf`);
          link.href = URL.createObjectURL(blob);
          link.click();
          URL.revokeObjectURL(link.href);
        } catch (error) {
          this.$notify({
            title: this.$t('key_header_error_downloading_file'),
            message: this.$t('key_message_error_downloading_file'),
            icon: { component: 'fa-solid fa-bomb', color: 'white' },
            color: 'danger',
            show: true,
            duration: 5000
          });
        } finally {
          this.isDownloadingDeliveryNote = false;
        }
      },
    }

  };

</script>

<style scoped>

  .image {
    height: 2.2rem !important;
    border-radius: 9%;
  }

  .units ul {
    list-style-type: none;
    padding: 0rem;
    margin-bottom: 0rem;
  }

  .scrollable {
    height: 25rem !important;
    overflow: auto;
  }

  .columns {
    max-width: 150px;
  }

</style>